import { SubjectLine } from 'sections/onsite-campaigns/types';
import { DomainRule } from '../../types';

export interface SubjectLineRequiredRuleDto {
  subjectLine: SubjectLine;
}

export const SubjectLineRequiredRuleKey = 'subjectLineRequired';

export const SubjectLineRequiredRule = (dto: SubjectLineRequiredRuleDto): DomainRule => {
  if (!dto.subjectLine?.id) {
    return {
      result: 'fail',
      ruleKey: SubjectLineRequiredRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: null,
  };
};
